import React, { FC, useState, useEffect } from 'react';
import { Pie, PieConfig } from '@ant-design/plots';
import { pileInfos } from '@/pages/ChargingPile/Monitor/components/UI/UI';
import type { MqttGroupData } from '@/types/database/chargingPile/chargingPileMqttData';

const GroupPileStatusPie: FC<{
  status: MqttGroupData['pileStatus'];
}> = ({ status }) => {
  const [pileData, setPileData] = useState<PieConfig['data']>([]);

  useEffect(() => {
    if (status) {
      const newData = Object.entries(status).map(([key, value]) => ({
        name: pileInfos[key].text,
        value,
      }));
      setPileData(newData.filter((data) => data.value > 0));
    }
  }, [status]);

  return (
    <Pie
      width={280}
      height={300}
      data={pileData}
      angleField="value"
      colorField="name"
      color={(datum) =>
        Object.values(pileInfos).find((info) => info.text === datum.name)
          ?.color || 'rgb(91, 143, 249)'
      }
      label={{
        type: 'inner',
        autoRotate: false,
        style: {
          fontSize: 16,
        },
      }}
      legend={{
        position: 'bottom',
        layout: 'horizontal',
        flipPage: false,
      }}
    />
  );
};

export default React.memo(GroupPileStatusPie);
